const searchResult = {
  br: 0,
  backgroundColor: ({ theme }) => theme.colors.white,
  labelColor: ({ theme }) => theme.colors.white,
  labelBackgroundColor: ({ theme }) => theme.colors.himmelsbla,
  labelBr: 0,
}

export default searchResult
